<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/w2p9ae/tc-custom/9780814761212.jpg?1726574218566" alt="This image is the cover for the book Shrinking Violets and Caspar Milquetoasts, The American Social Experience"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Shrinking Violets and Caspar Milquetoasts, The American Social Experience
      </h1>
      <p class="bookDescription body article font2">
        <p>Since World War II Americans’ attitudes towards shyness have changed. The women’s movement and the sexual revolution raised questions about communication, self-expression, intimacy, and personality, leading to new concerns about shyness. At the same time, the growth of psychotherapy and the mental health industry brought shyness to the attention of professionals who began to regard it as an illness in need of a cure. But what is shyness? How is it related to gender, race, and class identities? And what does its stigmatization say about our culture?<br/> In <b>Shrinking Violets and Caspar Milquetoasts</b>, Patricia McDaniel tells the story of shyness. Using popular self-help books and magazine articles she shows how prevailing attitudes toward shyness frequently work to disempower women. She draws on evidence as diverse as 1950s views of shyness as a womanly virtue to contemporary views of shyness as a barrier to intimacy to highlight how cultural standards governing shyness reproduce and maintain power differences between and among women and men.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patricia McDaniel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New York University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?37159a00